/**
 * 主应用外壳:全宽 sticky Header + 内容 Outlet + 多栏 Footer + 全局 Toaster。
 * 被所有「正常页」复用(登录页用 MinimalHeader 布局,不走此壳)。
 */
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { Toaster } from '@/components/ui/Toaster';

export function AppLayout() {
  return (
    <div className="page">
      <Header />
      <main className="main">
        <Outlet />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}
